gsap.registerPlugin(ScrollTrigger, SplitText);

const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const lenis = new Lenis({
  autoRaf: false,
  lerp : 0.1,
  smoothTouch : !isIOS
});

lenis.on('scroll', ScrollTrigger.update);



gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

window.lenis = lenis;

if (document.getElementById('preloader') || document.body.classList.contains('page-home')) {
  lenis.stop();
}

function pageLocksScroll() {
  return document.body.classList.contains('page-home') ||
    document.documentElement.classList.contains('scrollBlock');
}

function initMobileMenuLenisLock() {
  const menuLinks = document.querySelector('.site-header .menu-links');
  if (!menuLinks) return;

  const syncLenis = () => {
    if (
      menuLinks.classList.contains('open') ||
      pageLocksScroll()
    ) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  new MutationObserver(syncLenis).observe(menuLinks, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

window.animationState = {
  canStart: false,
  listeners: [],
};

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

window.setCanStartAnimations = function (value) {
  animationState.canStart = value;

  if (value) {
    animationState.listeners.forEach((fn) => fn());
    animationState.listeners = [];
  }
};

window.initInView = function (
  selector = '[data-animation]',
  options = {}
) {
  const {
    className = 'in-view',
    delay = 0,
    offset = '0px',
    root = document,
  } = options;

  const els = Array.from(root.querySelectorAll(selector));

  if (!els.length) return;

  // Respect reduced motion
  if (prefersReducedMotion) {
    els.forEach((el) => el.classList.add(className));
    return;
  }

  const groups = new Map();

  els.forEach((el) => {
    const elOffset = el.dataset.offset || offset;

    if (!groups.has(elOffset)) {
      groups.set(elOffset, []);
    }

    groups.get(elOffset).push(el);
  });

  function start() {
    groups.forEach((groupEls, rootMargin) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const elDelay = entry.target.dataset.delay;
            const computedDelay =
              elDelay !== undefined ? Number(elDelay) : delay;

            setTimeout(() => {
              entry.target.classList.add(className);
            }, computedDelay);

            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin,
          threshold: 0,
        }
      );

      groupEls.forEach((el) => {
        // Homepage bottles live in the locked 100dvh stage. On iOS,
        // IntersectionObserver often never fires for them (overflow:hidden
        // on html, translateY(100%) start pose). They are always on-screen,
        // so reveal without waiting for IO.
        if (el.closest('.product-shapes-wrap')) {
          const elDelay = el.dataset.delay;
          const computedDelay =
            elDelay !== undefined ? Number(elDelay) : delay;
          setTimeout(() => {
            el.classList.add(className);
          }, computedDelay);
          return;
        }
        observer.observe(el);
      });
    });
  }

  if (animationState.canStart) {
    start();
  } else {
    animationState.listeners.push(start);
  }
};
window.animateBodyText = function (elem, options = {}) {
  const {
    useScrollTrigger = true,
    autoPlay = true,
    delay = 0,
    onReady = null,
    autoSplit = true,
  } = options;

  if (!elem || elem.dataset.bodyAnimated === 'true') return null;

  elem.dataset.bodyAnimated = 'true';

  if (prefersReducedMotion) return null;

  return SplitText.create(elem, {
    type: 'words, lines',
    linesClass: 'line++',
    tag: 'span',
    ignore: '.insp-num, .insp-indent, .insp-mark, .insp-keep, .husen-mark, .husen-indent',
    autoSplit,
    aria : 'none',
    onSplit: (self) => {
      gsap.set(self.lines, {
        translateY: '30%',
        filter: "blur(10px)",
        opacity: 0,
      });

      const timelineConfig = useScrollTrigger
        ? {
            scrollTrigger: {
              trigger: elem,
              start: 'top 90%',
            },
          }
        : { paused: !autoPlay };

      const delaySec = Number(delay || elem.dataset.delay || 0);
      const startAt = delaySec > 20 ? delaySec / 1000 : delaySec;

      const tl = gsap.timeline(timelineConfig);
      tl.to(
        self.lines,
        {
          translateY: '0%',
          opacity: 1,
          filter: "blur(0px)",
          rotateX: '0deg',
          ease: 'power1.out',
          duration: 1,
          stagger: 0.1,
        },
        startAt
      );
      tl.add(() => {
        gsap.set(self.lines, { filter: 'none' });
      });

      elem._bodyLineTimeline = tl;
      elem._bodySplit = self;

      if (onReady) {
        onReady(elem);
      }

      return tl;
    },
  });
};

window.playBodyText = function (elem, delay = 0) {
  const tl = elem?._bodyLineTimeline;
  if (!tl) return;

  tl.pause(0);

  if (delay) {
    tl.delay(delay);
  } else {
    tl.delay(0);
  }

  tl.play();
};

window.resetBodyText = function (elem) {
  if (!elem) return;

  elem._bodyLineTimeline?.kill();
  elem._bodySplit?.revert();
  delete elem._bodyLineTimeline;
  delete elem._bodySplit;
  delete elem.dataset.bodyAnimated;
};

if (window.matchMedia('(max-width: 991px)').matches) {
  document.querySelectorAll('.page-content .left br, .house-about__copy br').forEach((br) => {
    br.replaceWith(document.createTextNode(' '));
  });
}

document.querySelectorAll('[data-animate="body"]').forEach((elem) => {
  if (elem.closest('.pdp-intro__more')) return;
  // Prose blocks are revealed by product-prose-scroll.js (pinned section).
  if (elem.closest('.pdp-about')) return;
  if (elem.closest('.about-husen')) return;
  if (elem.closest('.house-block--scatter')) return;
  if (elem.closest('.house-about')) return;
  if (elem.hasAttribute('data-hover-blur') || elem.closest('[data-hover-blur]')) return;
  if (elem.closest('.product-details')) return;
  if (elem.closest('.toplayout')) return;
  animateBodyText(elem);
});
document.addEventListener('DOMContentLoaded', () => {
  initInView('[data-animation]:not(.product-details *):not(.house-about__frames *)');
  initMobileMenuLenisLock();

  if (document.querySelector('.centered-wrapper')) {
    const start = () => setCanStartAnimations(true);
    window.peakLoveVtOnReady = start;
    if (window.peakLoveVtReady) start();
    setTimeout(() => {
      if (!window.animationState.canStart) start();
    }, 1000);
    return;
  }

  if (document.getElementById('preloader')) {
    // preloader.js calls setCanStartAnimations when it finishes. If that
    // path stalls on iOS (clip-path / logo callback), don't leave bottles
    // at opacity 0 forever.
    setTimeout(() => {
      if (!window.animationState.canStart) setCanStartAnimations(true);
    }, 2800);
    return;
  }

  setCanStartAnimations(true);
});

//transitions 